"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;
















































































































var _user = require("@/utils/user");
var _BedMulti = _interopRequireDefault(require("@/components/BedMulti")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { components: { BedMulti: _BedMulti.default }, data: function data() {return { tableData: [], // 列表数据
      imageList: [], newadd: false, ward: '', searchData: { ward: '', bedspace: '', page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, addData: { id: '', ward: '', bedspace: '' }, rules: { ward: [{ required: true, message: '请输入病房号', trigger: 'blur' }], bedspace: [{ required: true, message: '请输入床位号', trigger: 'blur' }] }, // 表格列
      tableColumns: [{ prop: 'ward', label: '病房号', isShow: true }, { prop: 'bedspace', label: '床位号', isShow: true }] };}, mounted: function mounted() {var self = this;self.init();}, methods: { init: function init() {var self = this;self.getData('/api/temi/medical/bed/robot/' + self.$route.params.parentId, self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, checkPermission: _user.checkPermission, resetFun: function resetFun() {// 重置
      this.searchData.ward = '';this.searchData.bedspace = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;this.init();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();}, addFun: function addFun() {// 新增
      var self = this;this.ward = '新增'; // this.newadd = true
      this.$refs.bed.handleShow = true;this.$refs.bed.init(self.$route.params.parentId);this.$refs.bed.bedIds = [];}, closeDiglog: function closeDiglog() {// 关闭弹出层
      this.$refs['addForm'].resetFields();this.cleanData();this.newadd = false;this.newadd2 = false;}, updateMenu: function updateMenu(item) {// 修改操作
      this.ward = '修改';var self = this;self.newadd = true;self.addData = { id: item.id, ward: item.ward, bedspace: item.bedspace };}, handleLookPatient: function handleLookPatient(item) {console.log(item);}, onSubmit: function onSubmit() {// 新增提交操作
      var self = this;self.$refs.addForm.validate(function (valid) {if (valid) {self.postData('/api/temi/medical/bed', self.addData, function (res) {self.$message({ message: '添加成功!', type: 'success' });self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    handlePostBed: function handlePostBed(bedIds) {// 新增提交操作
      if (bedIds && bedIds.length > 0) {
        var self = this;
        var postData = {
          'bedIds': bedIds,
          'robotId': self.$route.params.parentId };

        self.postData('/api/temi/medical/bed/robot/' + self.$route.params.parentId, postData, function (res) {
          self.$message({
            message: '添加成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }
    },

    delMenu: function delMenu(delId) {// 删除操作
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        var path = '/api/temi/medical/bed/robot/' + self.$route.params.parentId + '?id=' + delId;
        self.delData(path, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.$refs.addForm.resetFields();
      this.cleanData();
      this.newadd = false;
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData = {
        id: '',
        ward: '',
        bedspace: '' };

    },
    returnFun: function returnFun(item) {
      // 返回上一级
      var self = this;
      // self.$router.push('/temi/task')
      self.$router.go(-1);
    } } };exports.default = _default;